import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"
 
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Get initials from a name
 * For single words: first 2 characters
 * For multiple words: first letter of first word + first letter of last word
 */
export function getInitials(name: string): string {
  if (!name) return '';
  
  const trimmed = name.trim();
  const words = trimmed.split(/\s+/);
  
  if (words.length > 1) {
    // Multiple words: use first letter of first word + first letter of last word
    return (words[0][0] + words[words.length - 1][0]).toUpperCase();
  }
  
  // Single word: use first 2 characters
  return trimmed.slice(0, 2).toUpperCase();
} 